<template>
  <div class="card p-3 h-100 manage-card shadow-sm">
    <h6 class="pb-3 m-0 font-weight-bold">
      Booking Dates
    </h6>
    <table class="" v-if="!showEdit">
      <tr>
        <th class="font-weight-normal py-2 w-50"> Check In: </th>
        <td class="py-2">
          {{ dateTime(this.bookingDetails.booking_dates.checkin) }}
        </td>
      </tr>
      <tr>
        <th class="font-weight-normal py-2 w-50"> Check Out: </th>
        <td class="py-2">
          {{ dateTime(this.bookingDetails.booking_dates.checkout) }}
        </td>
      </tr>
    </table>
    <Transition name="slide-fade">
      <form v-if="showEdit" class="pb-3">
        <div class="mb-3">
          <label for="checkin">
            Check In:
          </label>
          <input class="form-control" id="checkin" type="date" v-model="checkinDate" :min="formatDatePicker(new Date())"
          @change="updateCheckoutDate()">
        </div>
        <div class="mb-3">
          <label for="checkout">
            Check Out:
          </label>
          <input class="form-control" id="checkout" type="date" v-model="dateOut" :min="formatDatePicker(nextDay)">
        </div>
      </form>
    </Transition>

    <div class="card-footer border-0 p-0 bg-white"
    v-if="!showEdit && !cancellationStatus">
      <p class="text-right mb-0 pt-2">
        <a href="#" class="text-xs text-reserva-orange hover:none absolute bottom-6 right-4" @click.prevent="showEditDatesInfo()">
          Change Dates
        </a>
      </p>
    </div>

    <div class="pb-2" v-if="showEdit">
      <div v-if="!dateChangeExtraPay" class="d-flex justify-items-center justify-content-between">
        <button class="back btn" type="button" @click.prevent="showEditDatesInfo()">
          Back
        </button>
        <!-- <button class="save btn" type="button" @click.prevent="saveChangedDates()"> -->
        <button class="save btn" type="button" @click.prevent="editBookingDates()">
          <div v-show="isSearching">
            <span v-html="manageSearchSpinner"></span>
          </div>
          <div v-show="!isSearching">Check Availability</div>
        </button>
      </div>
      <div v-else>
        <table class="card-body">
          <tr>
            <th class="font-weight-normal w-50 pr-3"> Old Price: </th>
            <td>
              {{ dateChangeExtraPay.oldPrice }}
            </td>
          </tr>
          <tr>
            <th class="font-weight-normal w-50"> New Price: </th>
            <td>
              {{ dateChangeExtraPay.newPrice }}
            </td>
          </tr>
        </table>
        <div class="my-3">
          <p class="m-0">
            <input id="checkbox" type="checkbox" value="accepted" class="mr-2"
            v-model='$v.acceptedterm.$model' />I accept the <a href="#terms">terms and conditions</a> and do agree {{ refundExtraCharges }} that are applicable.
          </p>
          <div class="" v-if='$v.acceptedterm.$error' :class='{ "form__input-error": $v.acceptedterm.$error }'>
            Please accept the terms before proceeding
          </div>
        </div>
        <div class="d-flex justify-items-center justify-content-between">
          <button class="back btn" type="button" @click.prevent="clearResponseData()">
            Cancel
          </button>
          <!-- <button class="save btn" type="button" @click.prevent="saveChangedDates()"> -->
          <button class="save btn" type="button" @click.prevent="saveDatesChanges()">
            Proceed
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

// const emit = defineEmits(['alert'])

// import Datepicker from "../../node_modules/@vuepic/vue-datepicker";
// import '../../node_modules/@vuepic/vue-datepicker/dist/main.css';
// import { ref } from 'vue'
import manageBooking from '../../mixins/manageBooking'
import reusableData from '../../mixins/reusableData'
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    cancellationStatus: ''
  },
  components: {
    // Datepicker
  },
  data () {
    return {
      showEdit: false,
      tommorow: '',
      checkinDate: '',
      dateOut: '',
      dateChangeExtraPay: '',
      bookings: '',
      bookingData: '',
      roomData: '',
      proofRes: 0,
      singleBoard: '',
      selectedRoom: '',
      acceptedterm: '',
      isSearching: false,
      manageSearchSpinner: "<i class='fa fa-spinner fa-spin'></i> SEARCHING"
    }
  },
  validations: {
    acceptedterm: { required }
  },
  methods: {
    dateTime (value) {
      return moment(value).format('ddd, DD MMM YYYY')
    },
    showEditDatesInfo () {
      this.showEdit = !this.showEdit
      this.checkinDate = this.bookingDetails.booking_dates.checkin
      this.dateOut = this.bookingDetails.booking_dates.checkout
    },
    formatDatePicker (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    updateCheckoutDate () {
      this.dateOut = moment(this.checkinDate).add(1, 'days').format('YYYY-MM-DD')
    },
    clearResponseData () {
      this.dateChangeExtraPay = ''
    },
    selectARoom () {
      this.selectedRoom = this.roomData.filter(room => room.id === parseInt(this.bookingDetails.room_id))
    },
    selectABoard () {
      var mealPlan = ''
      if (this.bookingDetails.boardName === 'bo') {
        mealPlan = 'Bed Only'
      } else if (this.bookingDetails.boardName === 'hb') {
        mealPlan = 'Half Board'
      } else if (this.bookingDetails.boardName === 'bb') {
        mealPlan = 'Bed & Breakfast'
      } else if (this.bookingDetails.boardName === 'fb') {
        mealPlan = 'fullboard'
      } else if (this.bookingDetails.boardName === 'ai') {
        mealPlan = 'all inclusive'
      } else {
        mealPlan = 'bed only'
      }
      this.singleBoard = this.selectedRoom[0].boards.filter(board => board.name === mealPlan)
    }
  },
  computed: {
    bookingDetails () {
      const allData = this.$store.getters.bookingDetails

      const sortedData = {
        room_id: allData.details[0].id,
        boardName: allData.details[0].meal_plan,
        booking_dates: {
          'reference': allData.reference_number,
          'checkin': allData.checkin_date,
          'checkout': allData.checkout_date
        }
      }

      return sortedData
    },
    nextDay () {
      var day = new Date(this.checkinDate)
      var nextDay = new Date(day)
      return nextDay.setDate(day.getDate() + 1)
    },
    refundExtraCharges () {
      var policiesStatement
      if (this.dateChangeExtraPay.extraPayRequired) {
        policiesStatement = 'to pay the extra charges'
      }
      if (this.dateChangeExtraPay.refundRequired) {
        policiesStatement = 'to comply with the refund policies'
      }
      if (this.dateChangeExtraPay.noPriceChange) {
        policiesStatement = 'to comply with the date change policies'
      }
      return policiesStatement
    }
  },
  mounted () {
    this.getUrlData()
  },
  watch: {
    bookingDetails: function (val) {
      this.checkinDate = val.booking_dates.checkin
      this.dateOut = val.booking_dates.checkout
    },
    roomData: function (val) {
      this.selectARoom()
      this.selectABoard()
    }
  },
  mixins: [manageBooking, reusableData]
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/manageBooking/subcomponents/BookingDates.vue